import BillingTransactionsLayout from "components/billing-module/billing-transactions/BillingTransactionsLayout";

const BillingTransactions = () => {
  return <BillingTransactionsLayout />;
};

export default BillingTransactions;
